import { useLanguage } from '../../hooks/useLanguage';

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    changeLanguage(currentLanguage === 'ar' ? 'en' : 'ar');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="group relative inline-flex items-center justify-center w-16 h-8 rounded-full bg-brand-accent text-brand-primary shadow-lg hover:shadow-xl hover:shadow-brand-accent/50 transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-brand-accent focus:ring-offset-2 focus:ring-offset-brand-primary overflow-hidden"
      aria-label="Switch language"
    >
      {/* Animated background - gold shimmer */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Language text with animation */}
      <span
        key={currentLanguage}
        className="relative font-heading font-bold text-sm uppercase tracking-wider z-10 animate-in"
      >
        {currentLanguage}
      </span>
      
      {/* Shine effect on hover */}
      <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out bg-gradient-to-r from-transparent via-white/40 to-transparent" />
    </button>
  );
}

